import React from 'react';
import { translate } from 'react-switch-lang';
import PropTypes from 'prop-types';
import LoginForm from './LoginForm';

function LoginCard({ t }) {
  return (
    <div className="card mt-4">
      <div className="card-body">
        <div className="text-center">
          <h4>{t('auth.LOGIN')}</h4>
          <h6>
            {t('auth.Enter your Username and Password')}
          </h6>
        </div>
        <LoginForm />
      </div>
    </div>
  );
}

LoginCard.propTypes = {
  t: PropTypes.func.isRequired,
};

export default translate(LoginCard);
